module.exports = {
    // SERVER_URL: "http://localhost:8080/api",
    SERVER_URL: "https://loyalreach.com/api",
    V_LOYAL_REACH: '57',
};



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = 635
// module chunks = 0 1 2